<template>
    <div class="platformList">
        <status-tabs
            :status.sync="status"
            :statusList="statusList"
            funcName="getOrdersList"
        ></status-tabs>

        <search-tool
            ref="searchTool"
            :status="status"
            :statusList="statusList"
            :funcName="funcName"
            :searchForm="searchForm"
            :searchList="searchList"
            :searchForm_transfer="searchForm_transfer"
            :advanceSearchFields="advanceSearchFields"
            listName="orders"
            :loading="loading"
            :menuAuth="menuAuth"
            :inputPlaceholder="inputPlaceholder"
            :selected="selectList.length"
        ></search-tool>

        <div class="table" :style="{ height: height }">
            <el-table
                :data="tableData"
                highlight-current-row
                height="100%"
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" align="center">
                </el-table-column>
                <el-table-column
                    :label="$t('platformList.tableName.name')"
                    align="left"
                    property="name"
                >
                </el-table-column>
                <el-table-column
                    :label="$t('platformList.tableName.code')"
                    property="code"
                    align="left"
                >
                </el-table-column>
                <el-table-column
                    :label="$t('platformList.tableName.desc')"
                    property="desc"
                    align="left"
                >
                </el-table-column>
                <el-table-column
                    :label="$t('platformList.tableName.sort')"
                    property="sort"
                    align="center"
                    width="100"
                >
                </el-table-column>
                <el-table-column
                    label="Created_at"
                    property="created_at"
                    align="left"
                >
                </el-table-column>
                <el-table-column
                    :label="$t('platformList.tableName.operation')"
                    align="left"
                    width="150"
                >
                    <template slot-scope="scope">
                        <operation :scope="scope" @rowDo="rowDo"></operation>
                    </template>
                </el-table-column>
                <el-empty :image-size="120" slot="empty">
                    <img slot="image" src="@/assets/image/empty-data.svg">
                </el-empty>
            </el-table>
        </div>
        <pagination
            :paginationData="paginationData"
            @paginationChange="paginationChange"
            :funcName="funcName"
        ></pagination>
        <add :addVisible.sync="addVisible"></add>
        <edit :editVisible.sync="editVisible" :tableItem="tableItem"></edit>
    </div>
</template>
<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { infoTagsMixins } from "@/utils/infoTagsMixins.js";
import { tableMixins } from "@/utils/tableMixins.js";
import add from "./platformList/add";
import edit from "./platformList/edit";
export default {
    mixins: [infoTagsMixins, tableMixins],
    data() {
        return {
            inputPlaceholder: "Keywords include Platform Name",
            countryList: {},
            searchForm: {
                name: "",
            },
            editVisible: false,
            addVisible: false,
            detailVisible: false,
            selectList: [],
            funcName: "platform",
            advanceSearchFields: {
                status: {
                    label: "Status",
                    type: "select",
                    options: [],
                },
            },
        };
    },
    components: {
        edit,
        add,
    },
    methods: {
        platform(page) {
            this.loading = true;
            page ? (this.paginationData.page = 1) : "";
            cmofferApi
                .platform(
                    {
                        ...this.searchForm,
                        ...this.paginationData,
                        menu_id: this.menu_id,
                    },
                    "get"
                )
                .then((res) => {
                    if (res) {
                        this.tableData = res.data;
                        this.menuAuth = res.ext.op_auth;
                        this.paginationData.total = res.total;
                        this.closeDrawer();
                        this.loading = false;
                        this.advanceSearchFields.status.options =
                            res.ext.tabs.map((item) => {
                                return { label: item.name, value: item.status };
                            });
                    }
                }).catch((err) => {
                    console.log('err: ', err);
                });
        },
        handleSelectionChange(val) {
            this.selectList = [];
            for (let i in val) {
                this.selectList.push(val[i].id);
            }
        },
        authFunc(funcName) {
            this[funcName]();
        },
        add() {
            this.addVisible = true;
        },
        /**
         * table内权限按钮
         */
        rowDo(item, row) {
            if (item.status_flag == 1) {
                this.tableItem = row;
                if (item.funcName == "edit") {
                    this.editVisible = true;
                } else if (item.funcName == "detail") {
                    this.detailVisible = true;
                }
            } else if (item.status_flag == 2) {
                this.$prompt(`Do you want to continue?`, "Tip", {
                    inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
                    inputErrorMessage: `Please enter ${item.name}Reason`,
                    inputPlaceholder: `${item.name}Reason`,
                })
                    .then(({ value }) => {
                        cmofferApi[item.funcName](
                            {
                                id_list: [row.id],
                                reason: value,
                            },
                            "put"
                        ).then((res) => {
                            if (res) {
                                if (res) {
                                    this.$message.success(
                                        `${item.name} Success`
                                    );
                                    this[item.parent_funcname]();
                                }
                            }
                        });
                    })
                    .catch(() => {
                        this.$message.info("Cancelled");
                    });
            } else if (item.status_flag == 3) {
                this.$confirm(`Do you want to continue?`, "Tip", {
                    type: "warning",
                })
                    .then(() => {
                        cmofferApi[item.funcName](
                            {
                                id_list: [row.id],
                            },
                            "put"
                        ).then((res) => {
                            if (res) {
                                if (res) {
                                    this.$message.success(
                                        `${item.name} Success`
                                    );
                                    this[item.parent_funcname]();
                                }
                            }
                        });
                    })
                    .catch(() => {
                        this.$message.info("Cancelled");
                    });
            } else if (item.status_flag == 4) {
                if (item.funcName == "delete") {
                    cmofferApi[item.parent_funcname](
                        {},
                        "delete",
                        item.rowId
                    ).then((res) => {
                        if (res) {
                            this.$message.success(`${item.name} Success`);
                            this[item.parent_funcname]();
                        }
                    });
                }
            }
        },
        clean() {
            this.searchForm = {
                name: "",
            };
        },
        searchTags(params) {
            this.searchForm[params.key] = params.value;
        },
    },
    created() {
        this.platform();
    },
    computed: {
    },
    watch: {
        searchForm: {
            handler(newValue) {
                for (let k in newValue) {
                    let v = newValue[k];
                    if (!!v && k !== 'status') {
                        this.hasSearchCondition = true;
                        return;
                    }
                }

                this.hasSearchCondition = false;
            },
            deep: true,
            immediate: true,
        },
    },
};
</script>
<style lang="scss">
.platformList {
    height: 100%;
    background: #fff;
    width: 100%;
    .table {
        margin: 0 15px !important;
        padding: 0 !important;
        width: auto !important;
    }
}
</style>
